import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, CalendarIcon, PrinterIcon, SearchIcon, UserIcon } from 'lucide-react';
interface UserSummary {
  id: string;
  userName: string;
  gateEntries: number;
  billing: number;
  gateExits: number;
  cashCount: number;
  cashAmount: number;
  qrCount: number;
  qrAmount: number;
  couponCount: number;
  couponAmount: number;
}
const users: {
  id: string;
  name: string;
}[] = [{
  id: '1',
  name: 'Rajesh Kumar'
}, {
  id: '2',
  name: 'Priya Sharma'
}, {
  id: '3',
  name: 'Amit Patel'
}, {
  id: '4',
  name: 'Sunil Verma'
}, {
  id: '5',
  name: 'Deepak Singh'
}, {
  id: '6',
  name: 'Meena Reddy'
}];
const userSummaries: Record<string, UserSummary> = {
  '1': {
    id: '1',
    userName: 'Rajesh Kumar',
    gateEntries: 45,
    billing: 42,
    gateExits: 40,
    cashCount: 20,
    cashAmount: 8500,
    qrCount: 15,
    qrAmount: 6200,
    couponCount: 7,
    couponAmount: 2800
  },
  '2': {
    id: '2',
    userName: 'Priya Sharma',
    gateEntries: 38,
    billing: 35,
    gateExits: 34,
    cashCount: 18,
    cashAmount: 7200,
    qrCount: 10,
    qrAmount: 4500,
    couponCount: 7,
    couponAmount: 3100
  },
  '3': {
    id: '3',
    userName: 'Amit Patel',
    gateEntries: 52,
    billing: 50,
    gateExits: 48,
    cashCount: 25,
    cashAmount: 10500,
    qrCount: 18,
    qrAmount: 7800,
    couponCount: 7,
    couponAmount: 2900
  },
  '4': {
    id: '4',
    userName: 'Sunil Verma',
    gateEntries: 30,
    billing: 28,
    gateExits: 27,
    cashCount: 14,
    cashAmount: 5600,
    qrCount: 8,
    qrAmount: 3200,
    couponCount: 6,
    couponAmount: 2400
  },
  '5': {
    id: '5',
    userName: 'Deepak Singh',
    gateEntries: 60,
    billing: 58,
    gateExits: 55,
    cashCount: 30,
    cashAmount: 12000,
    qrCount: 20,
    qrAmount: 8500,
    couponCount: 8,
    couponAmount: 3500
  },
  '6': {
    id: '6',
    userName: 'Meena Reddy',
    gateEntries: 22,
    billing: 20,
    gateExits: 19,
    cashCount: 10,
    cashAmount: 4200,
    qrCount: 6,
    qrAmount: 2500,
    couponCount: 4,
    couponAmount: 1600
  }
};
export function POSUserReportPage() {
  const [selectedUserId, setSelectedUserId] = useState('');
  const [startDate, setStartDate] = useState('2026-04-01');
  const [endDate, setEndDate] = useState('2026-04-15');
  const [hasGenerated, setHasGenerated] = useState(false);
  const summary = selectedUserId ? userSummaries[selectedUserId] : null;
  const totalAmount = summary ? summary.cashAmount + summary.qrAmount + summary.couponAmount : 0;
  const handleGenerate = () => {
    if (!selectedUserId) return;
    setHasGenerated(true);
  };
  const handlePrint = () => {
    document.body.classList.add('print-thermal');
    window.print();
    document.body.classList.remove('print-thermal');
  };
  return <div className="w-full max-w-4xl mx-auto" data-id="element-1070">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-5 xs:p-6 sm:p-8 no-print" data-id="element-1071">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-1072">
          <div className="flex items-center gap-3" data-id="element-1073">
            <div className="bg-brand-teal/10 p-2 rounded-xl border border-brand-teal/20" data-id="element-1074">
              <UsersIcon className="w-6 h-6 text-brand-teal" data-id="element-1075" />
            </div>
            <div data-id="element-1076">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight" data-id="element-1077">
                POS User Report
              </h2>
              <p className="text-sm text-slate-500" data-id="element-1078">
                Quick user summary for thermal print (80mm).
              </p>
            </div>
          </div>
          {hasGenerated && summary && <button onClick={handlePrint} className="inline-flex items-center justify-center gap-2 bg-brand-teal text-white px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-brand-tealHover transition-colors" data-id="element-1079">
              <PrinterIcon className="w-4 h-4" data-id="element-1080" />
              Print (80mm)
            </button>}
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8 p-4 bg-slate-50 rounded-xl border border-slate-200" data-id="element-1081">
          <div className="flex-1" data-id="element-1082">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1083">
              Select User
            </label>
            <div className="relative" data-id="element-1084">
              <UserIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1085" />
              <select value={selectedUserId} onChange={e => {
              setSelectedUserId(e.target.value);
              setHasGenerated(false);
            }} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all appearance-none" data-id="element-1086">
                <option value="" data-id="element-1087">-- Select User --</option>
                {users.map(u => <option key={u.id} value={u.id} data-id="element-1088">
                    {u.name}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="flex-1" data-id="element-1089">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1090">
              Start Date
            </label>
            <div className="relative" data-id="element-1091">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1092" />
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-1093" />
            </div>
          </div>
          <div className="flex-1" data-id="element-1094">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1095">
              End Date
            </label>
            <div className="relative" data-id="element-1096">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1097" />
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-1098" />
            </div>
          </div>
          <div className="flex items-end" data-id="element-1099">
            <button onClick={handleGenerate} disabled={!selectedUserId} className="w-full sm:w-auto px-6 py-2.5 bg-slate-800 text-white rounded-xl font-medium text-sm hover:bg-slate-700 transition-colors flex items-center justify-center gap-2 h-[42px] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1100">
              <SearchIcon className="w-4 h-4" data-id="element-1101" />
              Generate
            </button>
          </div>
        </div>

        {/* Screen Summary */}
        {hasGenerated && summary && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} data-id="element-1102">
            <div className="flex items-center gap-3 mb-5 pb-3 border-b border-slate-200" data-id="element-1103">
              <div className="w-9 h-9 rounded-full bg-brand-teal/10 flex items-center justify-center" data-id="element-1104">
                <UserIcon className="w-4.5 h-4.5 text-brand-teal" data-id="element-1105" />
              </div>
              <div data-id="element-1106">
                <h3 className="text-base font-bold text-slate-900" data-id="element-1107">
                  {summary.userName}
                </h3>
                <p className="text-xs text-slate-500" data-id="element-1108">
                  {startDate} to {endDate}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3 mb-5" data-id="element-1109">
              <div className="bg-blue-50 rounded-xl p-3 border border-blue-100 text-center" data-id="element-1110">
                <p className="text-xs font-semibold text-blue-600 mb-1" data-id="element-1111">
                  Gate Entries
                </p>
                <p className="text-2xl font-bold text-blue-800" data-id="element-1112">
                  {summary.gateEntries}
                </p>
              </div>
              <div className="bg-amber-50 rounded-xl p-3 border border-amber-100 text-center" data-id="element-1113">
                <p className="text-xs font-semibold text-amber-600 mb-1" data-id="element-1114">
                  Billing
                </p>
                <p className="text-2xl font-bold text-amber-800" data-id="element-1115">
                  {summary.billing}
                </p>
              </div>
              <div className="bg-green-50 rounded-xl p-3 border border-green-100 text-center" data-id="element-1116">
                <p className="text-xs font-semibold text-green-600 mb-1" data-id="element-1117">
                  Gate Exits
                </p>
                <p className="text-2xl font-bold text-green-800" data-id="element-1118">
                  {summary.gateExits}
                </p>
              </div>
            </div>

            <div className="border border-slate-200 rounded-xl overflow-hidden mb-5" data-id="element-1119">
              <table className="w-full text-sm" data-id="element-1120">
                <thead className="bg-slate-50 border-b border-slate-200 text-slate-500" data-id="element-1121">
                  <tr data-id="element-1122">
                    <th className="px-4 py-2.5 text-left font-semibold" data-id="element-1123">
                      Payment Mode
                    </th>
                    <th className="px-4 py-2.5 text-center font-semibold" data-id="element-1124">
                      Count
                    </th>
                    <th className="px-4 py-2.5 text-right font-semibold" data-id="element-1125">
                      Amount (₹)
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-1126">
                  <tr data-id="element-1127">
                    <td className="px-4 py-2.5 font-medium text-slate-700" data-id="element-1128">
                      Cash
                    </td>
                    <td className="px-4 py-2.5 text-center" data-id="element-1129">
                      {summary.cashCount}
                    </td>
                    <td className="px-4 py-2.5 text-right" data-id="element-1130">
                      ₹{summary.cashAmount.toLocaleString()}
                    </td>
                  </tr>
                  <tr data-id="element-1131">
                    <td className="px-4 py-2.5 font-medium text-slate-700" data-id="element-1132">
                      QR
                    </td>
                    <td className="px-4 py-2.5 text-center" data-id="element-1133">
                      {summary.qrCount}
                    </td>
                    <td className="px-4 py-2.5 text-right" data-id="element-1134">
                      ₹{summary.qrAmount.toLocaleString()}
                    </td>
                  </tr>
                  <tr data-id="element-1135">
                    <td className="px-4 py-2.5 font-medium text-slate-700" data-id="element-1136">
                      Coupon
                    </td>
                    <td className="px-4 py-2.5 text-center" data-id="element-1137">
                      {summary.couponCount}
                    </td>
                    <td className="px-4 py-2.5 text-right" data-id="element-1138">
                      ₹{summary.couponAmount.toLocaleString()}
                    </td>
                  </tr>
                </tbody>
                <tfoot className="bg-slate-50 border-t border-slate-200 font-bold" data-id="element-1139">
                  <tr data-id="element-1140">
                    <td className="px-4 py-2.5" data-id="element-1141">Total</td>
                    <td className="px-4 py-2.5 text-center text-brand-teal" data-id="element-1142">
                      {summary.cashCount + summary.qrCount + summary.couponCount}
                    </td>
                    <td className="px-4 py-2.5 text-right text-brand-teal" data-id="element-1143">
                      ₹{totalAmount.toLocaleString()}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </motion.div>}

        {!hasGenerated && <div className="border-2 border-dashed border-slate-200 rounded-xl p-8 text-center bg-slate-50" data-id="element-1144">
            <UserIcon className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-1145" />
            <p className="text-slate-500 text-sm font-medium" data-id="element-1146">
              Select a user and date range to generate report
            </p>
          </div>}
      </motion.div>

      {/* 80mm Thermal Print Layout */}
      {hasGenerated && summary && <div id="print-receipt" className="hidden print:block bg-white font-mono text-[11px] leading-[1.4] text-black p-4 w-[302px] print:w-[80mm] print:p-[4mm]" data-id="element-1147">
          <div className="text-center mb-1" data-id="element-1148">
            <div className="text-[15px] font-bold tracking-wide" data-id="element-1149">
              ERPLogiPark
            </div>
            <div className="text-[9px] leading-tight mt-0.5 text-gray-700" data-id="element-1150">
              Terminal Management &amp; Gate Automation
            </div>
          </div>
          <div className="text-center text-[9px] leading-tight text-gray-600 mb-2" data-id="element-1151">
            Plot No. 45, Logistics Hub, Sector 18
            <br data-id="element-1152" />
            Industrial Area, Bangalore - 560100
          </div>

          <div className="border-t border-dashed border-gray-400 my-2" data-id="element-1153" />

          <div className="text-center font-bold text-[12px] tracking-wider mb-1" data-id="element-1154">
            USER ACTIVITY REPORT
          </div>
          <div className="text-center text-[10px] font-bold mb-0.5" data-id="element-1155">
            {summary.userName}
          </div>
          <div className="text-center text-[9px] text-gray-600 mb-1" data-id="element-1156">
            {startDate} to {endDate}
          </div>

          <div className="border-t border-dashed border-gray-400 my-2" data-id="element-1157" />

          {/* Activity Summary */}
          <div className="space-y-[4px] mb-2" data-id="element-1158">
            <div className="flex justify-between text-[11px]" data-id="element-1159">
              <span data-id="element-1160">Gate Entries:</span>
              <span className="font-bold" data-id="element-1161">{summary.gateEntries}</span>
            </div>
            <div className="flex justify-between text-[11px]" data-id="element-1162">
              <span data-id="element-1163">Billing:</span>
              <span className="font-bold" data-id="element-1164">{summary.billing}</span>
            </div>
            <div className="flex justify-between text-[11px]" data-id="element-1165">
              <span data-id="element-1166">Gate Exits:</span>
              <span className="font-bold" data-id="element-1167">{summary.gateExits}</span>
            </div>
          </div>

          <div className="border-t border-dashed border-gray-400 my-2" data-id="element-1168" />

          {/* Payment Summary */}
          <div className="text-[10px] font-bold mb-1" data-id="element-1169">PAYMENT SUMMARY</div>
          <div className="space-y-[4px]" data-id="element-1170">
            <div className="flex justify-between text-[11px]" data-id="element-1171">
              <span data-id="element-1172">Cash ({summary.cashCount}):</span>
              <span className="font-bold" data-id="element-1173">
                ₹{summary.cashAmount.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between text-[11px]" data-id="element-1174">
              <span data-id="element-1175">QR ({summary.qrCount}):</span>
              <span className="font-bold" data-id="element-1176">
                ₹{summary.qrAmount.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between text-[11px]" data-id="element-1177">
              <span data-id="element-1178">Coupon ({summary.couponCount}):</span>
              <span className="font-bold" data-id="element-1179">
                ₹{summary.couponAmount.toLocaleString()}
              </span>
            </div>
          </div>

          <div className="border-t border-dotted border-gray-300 my-2" data-id="element-1180" />

          <div className="flex justify-between font-bold text-[13px]" data-id="element-1181">
            <span data-id="element-1182">TOTAL:</span>
            <span data-id="element-1183">₹{totalAmount.toLocaleString()}</span>
          </div>

          <div className="border-t border-dashed border-gray-400 my-3" data-id="element-1184" />

          <div className="text-center text-[8px] text-gray-500 leading-tight" data-id="element-1185">
            <div data-id="element-1186">Generated: {new Date().toLocaleString()}</div>
            <div data-id="element-1187">This is a computer generated report.</div>
            <div className="mt-1" data-id="element-1188">© 2026 ERPLogiPark</div>
          </div>
        </div>}
    </div>;
}